import { useAppSelector } from "hooks/reduxHooks";
import { selectCurrentExam } from "store/ExamStore/selectors";
import {
  ConfidenceBand,
  getConfidenceBand,
  getExamLegFocus,
  getTrackingConfidenceScore,
} from "utils/confidenceScore";

const bandClasses: Record<ConfidenceBand, string> = {
  green: "bg-green-100 text-green-700",
  yellow: "bg-yellow-100 text-yellow-700",
  red: "bg-red-100 text-red-700",
};

export const ConfidenceScoreBadge = () => {
  const exam = useAppSelector(selectCurrentExam);

  const focus = getExamLegFocus(exam?.joint);
  const score = getTrackingConfidenceScore(exam?.examMLResult, focus);
  const band = getConfidenceBand(score);

  // Old exams without confidence fields: hide the indicator entirely
  if (score === null || band === null) {
    return null;
  }

  return (
    <article>
      <h3>Confidence Score</h3>
      <div className="flex items-center mt-4">
        <span
          className={`inline-flex items-center px-4 py-2 rounded-[10px] font-black text-lg ${bandClasses[band]}`}
        >
          {score.toFixed(1)} / 10
        </span>
      </div>
    </article>
  );
};
